import localforage from 'localforage';

// Store video start times and metadata for recovery purposes
export const backupRecords = localforage.createInstance({
  name: 'backupRecords',
  storeName: 'backupRecords',
});

// Will be used to store the chunks of the current recordings
export const chunks = localforage.createInstance({
  name: 'chunks',
  storeName: 'chunks',
});
